import { createAsyncThunk } from '@reduxjs/toolkit';

import { authService } from 'services';
import { Credentials } from 'interfaces';
import axios from 'axios';

export const signIn = createAsyncThunk<void, Credentials>(
  'auth/signIn',
  async (credentials, { rejectWithValue }) => {
    try {
      const { accessToken, refreshToken } = await authService.signIn(
        credentials
      );

      localStorage.setItem('accessToken', `Bearer ${accessToken}`);
      localStorage.setItem('refreshToken', refreshToken);
    } catch (err) {
      if (axios.isAxiosError(err) && err.response)
        return rejectWithValue(err.response.data.message);
      if (err instanceof Error) {
        return rejectWithValue(err.message);
      }
      return rejectWithValue(err);
    }
  }
);
